import { useState } from "react";

// component
import Map from "./Map";

// style
import classes from "./ContactUs.module.scss";

// utils
import {
  isValidEmail,
} from "@/utils/util";

// validate input, return true if it is invalid
const validateInput = (
  value,
  condition,
  errorMessage,
  currentMessage,
  setErrorMessage
) => {
  if (value.trim() === "" || condition) {
    setErrorMessage(errorMessage);
    return true;
  } else if (currentMessage !== "") {
    setErrorMessage("");
  }
  return false;
};

// contact us page
const ContactUs = (props) => {
  const {
    contactUsRichText,
    stores,
    isEnableEnquiry,
    input,
    setInput,
    handleFormSubmit,
  } = props;
  const [onSubmit, setOnSubmit] = useState(false);
  const [nameErrorMessage, setNameErrorMessage] = useState("");
  const [emailErrorMessage, setEmailErrorMessage] = useState("");
  const [enquiryErrorMessage, setEnquiryErrorMessage] = useState("");

  const checkInput = () => {
    // disable inputs and button
    setOnSubmit(true);
    // check input
    const checkName = validateInput(
      input.name,
      !(3 <= input.name.length && input.name.length <= 32),
      "Name must be between 3 and 32 characters!",
      nameErrorMessage,
      setNameErrorMessage
    );
    const checkEmail = validateInput(
      input.email,
      !isValidEmail(input.email),
      "E-Mail Address does not appear to be valid!",
      emailErrorMessage,
      setEmailErrorMessage
    );
    const checkEnquiry = validateInput(
      input.enquiry,
      !(10 <= input.enquiry.length && input.enquiry.length <= 3000),
      "Enquiry must be between 10 and 3000 characters!",
      enquiryErrorMessage,
      setEnquiryErrorMessage
    );

    if (checkName || checkEmail || checkEnquiry) {
      setOnSubmit(false);
      return;
    } else {
      handleFormSubmit();
      setOnSubmit(false);
    }
  };
  const onInputChange = (e) => {
    setInput({ ...input, [e.target.name]: e.target.value });
  };
  return (
    <div>
      <div className="md:my-[30px] md:mx-[2%] ">
        <h1 className="text-[40px] font-semibold pb-5">Contact Us</h1>
        <div dangerouslySetInnerHTML={{ __html: contactUsRichText }} />
      </div>

      <div className="my-16">
        {stores.length > 0 && (
          <div className="my-4">
            <Map stores={stores} />
          </div>
        )}
      </div>
      {isEnableEnquiry ? (
        <div className={`${classes.form} ${"my-16 p-8 sm:px-[20%] sm:py-16"}`}>
          <h2 className="text-center font-semibold sm:text-[27px] text-lg">
            Contact Form
          </h2>
          <div>
            <label className="text-sm sm:text-lg">Your name</label>
            <input
              type="text"
              className="w-full"
              value={input.name}
              onChange={onInputChange}
              disabled={onSubmit}
              name="name"
            />
            <p>{nameErrorMessage}</p>
          </div>
          <div>
            <label className="text-sm sm:text-lg">E-mail address</label>
            <input
              type="email"
              className="w-full"
              value={input.email}
              onChange={onInputChange}
              disabled={onSubmit}
              name="email"
            />
            <p>{emailErrorMessage}</p>
          </div>
          <div>
            <label className="text-sm sm:text-lg">Enquiry</label>
            <textarea
              className="w-full"
              value={input.enquiry}
              onChange={onInputChange}
              disabled={onSubmit}
              name="enquiry"
            />
            <p>{enquiryErrorMessage}</p>
          </div>
          <button
            type="submit"
            className="bg-primary text-white font-semibold rounded-[10px] w-1/2 max-w-[100px] py-1.5 px-0 text-sm
            sm:w-auto sm:max-w-full sm:px-9 sm:text-lg disabled:bg-gray-300"
            onClick={checkInput}
            disabled={onSubmit}
          >
            Submit
          </button>
        </div>
      ) : null}
    </div>
  );
};

export default ContactUs;
